import { Link } from "@onclicks/sharedmobilei18n/routing";

export const LinkElementMenuMobile = ({
  textLink,
  linkHref,
}: {
  textLink: string;
  linkHref: string;
}) => {
  return (
    <Link href={linkHref} className="block hover:bg-white/5 rounded py-2">
      {textLink}
    </Link>
  );
};
